import { Navigate } from 'react-router-dom'

export default function ClientRouteRedirect() {
  return <Navigate to="/report" replace />
}
